<template>
  <div class="bottom-checkbox fixed pin-b pin-l w-screen py-5 px-6 bg-white">
    <div class="mb-2">{{ $t('Scroll to validate') }}</div>
    <div class="flex">
      <div class="checkbox border border-grey mr-2 rounded-sm" />
      <BaseGreyText v-if="greyTheme">
        {{ $t('Accept') }}
      </BaseGreyText>
      <div v-else>{{ $t('Accept') }}</div>
    </div>
  </div>
</template>

<script>
import BaseGreyText from './BaseGreyText.vue';

export default {
  name: 'TheBottomCheckbox',
  components: {
    BaseGreyText,
  },
  props: {
    greyTheme: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
 height: 18px;
 width: 18px;
}
.bottom-checkbox {
  &::before {
    content: '';
    height: 54px;
    width: 100%;
    background:
      linear-gradient(0, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 12%),
      linear-gradient(0, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%);
    position: absolute;
    left: 0;
    bottom: 100%;
  };
}
</style>
